import { render } from "./presentercta.vue?vue&type=template&id=7e1243ab&scoped=true"
import script from "./presentercta.vue?vue&type=script&lang=js"
export * from "./presentercta.vue?vue&type=script&lang=js"

import "./presentercta.vue?vue&type=style&index=0&id=7e1243ab&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e1243ab"

export default script